// eslint-disable-next-line import/prefer-default-export
export const calculateMessageAmount = (count, messageProduct) => {
  const countParseInt = count ? parseInt(count, 10) : 0
  return messageProduct.unitPrice * countParseInt
}
